import React, { useContext, useState } from "react";
import "../createreq.css";
import { GlobalInfo } from "../App";
import { create } from "ipfs-http-client";

const client = create("https://ipfs.infura.io:5001/api/v0");
export default function () {
  const { val, acc, getupdate } = useContext(GlobalInfo);
  const [fileUrl, updateFileUrl] = useState(``);
  // const [fileUrl2, updateFileUrl2] = useState(``);
  async function onChange(e) {
    const file = e.target.files[0];
    try {
      const added = await client.add(file);
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;
      updateFileUrl(url);
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  }
  const creates = async () => {
    const { web3, contract } = val;
    var a = document.getElementById("category").value;
    var b = document.getElementById("description").value;
    var f = "";
    var g = fileUrl;
    var c = document.getElementById("Address").value;
    var d = document.getElementById("Deadline").value;
    var e = document.getElementById("Amount").value;

    const toTimestamp = (strDate) => {
      const dt = Date.parse(strDate);
      return dt / 1000;
    };
    var d = toTimestamp(d);
    await contract.createRequests(
      a,
      b,
      f,
      g,
      c,
      d,
      web3.utils.toWei(e, "ether"),
      {
        from: acc,
      }
    );

    getupdate();
  };

  return (
    <>
      <div>
        <center>
          <h1>Create Requests</h1>
          <div className="container">
            <input id="category" placeholder="Category" size="{50}" required />
            <input
              id="description"
              placeholder="description"
              size="{50}"
              required
            />
            <input id="Address" placeholder="Address" size="{50}" required />
            <input
              type="date"
              id="Deadline"
              placeholder="Deadline in sec"
              size="{50}"
              required
            />
            <input
              id="Amount"
              placeholder="Target Amount"
              size="{50}"
              required
            />
            <div className="App">
              <input type="file" onChange={onChange} required />
              {fileUrl && <img src={fileUrl} width="600px" />}
            </div>
            <button type="submit" onClick={creates}>
              Submit
            </button>
          </div>
        </center>
      </div>
    </>
  );
}
